import axios from 'axios'
import { UrlBase } from './config'

const cancelToken = axios.CancelToken
let sourceUsers = cancelToken.source()
let sourceInvitedUsers = cancelToken.source()

const users = {}

users.addUserToList = (token, companyId, appId, userId, listId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/users/' + userId + '/add/to/list',
      data: {
        listId: listId
      }
    }

    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) {
        return reject(new Error(error.message))
      } else {
        return reject(new Error(message.data.error))
      }
    })
  })
}

users.changeOrAddExtraDataInBlock = async (token, companyId, appId, { extradata, usersIds }) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        usersIds,
        extradata
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/bulk/change/extradata`
    }
    await axios(request)
  } catch (e) {
    const message = e.response.data.error
    if (message) throw new Error(message)
    throw new Error(e.message)
  }
}

users.changePassword = (token, currentPassword, newPassword) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'users/changepassword',
      data: { currentPassword, newPassword }
    }
    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) {
          return reject(new Error(error.message))
        } else {
          return reject(new Error(message.data.error))
        }
      })
  })
}

users.changeUsersJourneyInBlock = async (token, companyId, appId, { journeyId, usersIds }) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        usersIds,
        journeyId
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/bulk/change/journeys`
    }
    await axios(request)
  } catch (e) {
    const message = e.response.data.error
    if (message) throw new Error(message)
    throw new Error(e.message)
  }
}

users.createNewTaskInBlock = async (token, companyId, appId, { task, usersIds }) => {
  const { name, date, done, extraData, observation, reportToUser, sendEmailNotificationTo, sendPhoneNotificationTo } = task
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        usersIds,
        name,
        date,
        done,
        extraData,
        observation,
        reportToUser,
        sendEmailNotificationTo,
        sendPhoneNotificationTo
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/bulk/change/tasks`
    }
    await axios(request)
  } catch (e) {
    const message = e.response.data.error
    if (message) throw new Error(message)
    throw new Error(e.message)
  }
}

users.changeUserResponsibleInBlock = async (token, companyId, appId, { responsibleId, usersIds }) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        usersIds,
        responsibleId
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/bulk/change/responsible`
    }
    await axios(request)
  } catch (e) {
    const message = e.response.data.error
    if (message) throw new Error(message)
    throw new Error(e.message)
  }
}

users.createUser = (token, companyId, appId, { email, name, lastName, rolId, phone, country, countryCode }) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/users',
      data: { email, name, lastName, rolId, phone, country, countryCode }
    }
    axios(options)
      .then(response => {
        resolve(response.data.user)
      })
      .catch(error => {
        const message = error.response
        if (!message) {
          return reject(new Error(error.message))
        } else {
          return reject(new Error(message.data.error))
        }
      })
  })
}

users.deleteUser = (token, companyId, appId, userId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/users/' + userId
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) {
        return reject(new Error(error.message))
      } else {
        return reject(new Error(message.data.error))
      }
    })
  })
}

users.deleteUserDocument = async (token, companyId, appId, userId, documentId) => {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/${userId}/document/${documentId}`
    }
    await axios(request)
    return true
  } catch (e) {
    const message = e.response
    if (!message) {
      throw new Error(e.message)
    } else {
      throw new Error(message)
    }
  }
}

users.generateKeys = (token, genPublicKey, genPrivateKey) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'users/genpublickey',
      data: { genPublicKey, genPrivateKey }
    }

    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) {
        return reject(new Error(error.message))
      } else {
        return reject(new Error(message.data.error))
      }
    })
  })
}

users.generateOneTimePassword = (token, companyId, appId, uuid, { sendMail, sendPhone }) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/users/' + uuid + '/onetimepassword',
      data: { sendMail, sendPhone }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  })
}

users.getAdminUserInfo = (token) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'users/'
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) {
          return reject(new Error(error.message))
        } else {
          return reject(new Error(message.data.error))
        }
      })
  })
}

users.getExtradataLabels = (token, companyId, appId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/extradatalabel`
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) {
        return reject(new Error(error.message))
      } else {
        return reject(new Error(message.data.error))
      }
    })
  })
}

users.getHistoricalOfUserActions = (token, companyId, appId, uuid) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/users/' + uuid + '/historical'
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      console.log(error)
    })
  })
}

users.getPublicKey = token => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'users/genpublickey'
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) {
        return reject(new Error(error.message))
      } else {
        return reject(new Error(message.data.error))
      }
    })
  })
}

users.getUser = (token, companyId, appId, uuid, fromChat) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        entryPoint: fromChat || undefined
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/${uuid}`
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) {
          return reject(new Error(error.message))
        } else {
          return reject(new Error(message.data.error))
        }
      })
  })
}

users.getUserLikings = async (token, companyId, appId, userId) => {
  try {
    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      method: 'GET',
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/${userId}/likings`
    }

    const response = await axios(request)

    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

users.getUserSpotifyTops = (token, companyId, appId, userId) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/${userId}/spotify/insights`
    }
    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) {
          return reject(new Error(error.message))
        } else {
          console.error(error)
          return resolve(false)
        }
      })
  })
}

users.getInvitedUsers = (token, companyId, appId, pagination, search) => {
  sourceInvitedUsers.cancel('Operation canceled')
  sourceInvitedUsers = cancelToken.source()
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage,
        search: search
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/invited',
      cancelToken: sourceInvitedUsers.token
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message !== 'Operation canceled') console.log(error)
      })
  })
}

users.getUsers = (token, companyId, appId, pagination, search, advancedSearch, data) => {
  const { headers } = data
  sourceUsers.cancel('Operation canceled')
  sourceUsers = cancelToken.source()

  return new Promise((resolve, reject) => {
    const extradata = Object.keys(advancedSearch.extradata).length > 0 ? JSON.stringify(advancedSearch.extradata) : undefined
    let likings = {}
    let spotifyGenres = {}
    let spotifyArtists = {}
    let spotifyTracks = {}

    if (advancedSearch.usersLikings.or.length > 0) {
      likings.or = advancedSearch.usersLikings.or
    }

    if (advancedSearch.usersLikings.and.length > 0) {
      likings.and = advancedSearch.usersLikings.and
    }

    if (advancedSearch.spotifyGenres.or.length > 0) {
      spotifyGenres.or = advancedSearch.spotifyGenres.or
    }
    if (advancedSearch.spotifyGenres.and.length > 0) {
      spotifyGenres.and = advancedSearch.spotifyGenres.and
    }

    if (advancedSearch.spotifyArtists.or.length > 0) {
      spotifyArtists.or = advancedSearch.spotifyArtists.or
    }
    if (advancedSearch.spotifyArtists.and.length > 0) {
      spotifyArtists.and = advancedSearch.spotifyArtists.and
    }

    if (advancedSearch.spotifyTracks.or.length > 0) {
      spotifyTracks.or = advancedSearch.spotifyTracks.or
    }
    if (advancedSearch.spotifyTracks.and.length > 0) {
      spotifyTracks.and = advancedSearch.spotifyTracks.and
    }

    if (!likings.or && !likings.and) likings = null
    if (!spotifyGenres.or && !spotifyGenres.and) spotifyGenres = null
    if (!spotifyArtists.or && !spotifyArtists.and) spotifyArtists = null
    if (!spotifyTracks.or && !spotifyTracks.and) spotifyTracks = null

    const params = {
      page: pagination.page,
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      likings,
      spotifyGenres,
      spotifyArtists,
      spotifyTracks,
      limit: pagination.itemsPerPage,
      rolIdArray: advancedSearch.roles,
      search: search,
      socialNetworks: advancedSearch.socialNetworks,
      verified: advancedSearch.verified || '',
      extradata,
      evaluator: 'all',
      dateTimeUnit: 'HOUR',
      journeyArray: advancedSearch.journeyArray,
      filterResponsible: advancedSearch.filterResponsible
    }
    if (advancedSearch.isImported !== null && advancedSearch.isImported !== undefined) {
      params.isImported = advancedSearch.isImported
    }
    if (headers && headers.length > 0) {
      const temp = []
      headers.forEach(extraData => {
        temp.push(extraData.value)
      })

      if (!temp.includes('UUID')) {
        temp.push('UUID')
      }

      params.extraFields = temp
    }

    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params,
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/users',
      cancelToken: sourceUsers.token
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        if (error.message !== 'Operation canceled') console.log(error)
        const message = error.response
        if (!message) return reject(new Error(error.message))
        return reject(new Error(message.data.error))
      })
  })
}

users.getUserDocuments = async (token, companyId, appId, userId) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/${userId}/document`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) {
      throw new Error(e.message)
    } else {
      throw new Error(message)
    }
  }
}

users.updateAdminUserInfo = async (token, data) => {
  try {
    const request = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data,
      url: `${UrlBase}users`
    }
    await axios(request)
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

users.updateUser = async (token, companyId, appId, data) => {
  const { userId, name, lastName, password, email, phone, country, countryCode, extraData, rolId, rmrolId, inactive, journeyId, responsibleId } = data
  try {
    const options = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/users/' + userId,
      data: { name, lastName, password, email, phone, country, countryCode, extraData, rolId, rmrolId, inactive, journeyId, responsibleId }
    }
    const response = await axios(options)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    throw new Error(message.data.error)
  }
}

users.updateUserExtradata = (token, companyId, appId, userId, { extradata }) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/users/' + userId,
      data: { extradata }
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) {
        return reject(new Error(error.message))
      } else {
        return reject(new Error(message.data.error))
      }
    })
  })
}

users.updateUserDocument = async (token, companyId, appId, { description, userId, id }) => {
  try {
    const request = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        description
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/${userId}/document/${id}`
    }
    await axios(request)
    return true
  } catch (e) {
    const message = e.response
    if (!message) {
      throw new Error(e.message)
    } else {
      throw new Error(message)
    }
  }
}

users.uploadUserDocument = async (token, companyId, appId, userId, { file, type }) => {
  try {
    const fd = new FormData()
    fd.append('document-file', file)
    fd.append('type', type)
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: fd,
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/${userId}/document`
    }
    await axios(request)
    return true
  } catch (e) {
    const message = e.response
    if (!message) {
      throw new Error(e.message)
    } else {
      throw new Error(message)
    }
  }
}

users.sendSmsToUser = async (token, companyId, appId, data) => {
  const { country, countryCode, message, phone } = data
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/send/sms`,
      data: { country, countryCode, message, phone }
    }
    return await axios(request)
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

users.sendSms = (token, companyId, appId, message, filters) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/users/sendsms',
      data: {
        extradata: filters.extradata,
        search: filters.search,
        socialNetworks: filters.socialNetworks,
        verified: filters.verified || '',
        message: message
      }
    }

    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) {
          return reject(new Error(error.message))
        } else {
          return reject(new Error(message.data.error))
        }
      })
  })
}

users.sendSmsInvitedUsers = (token, companyId, appId, message, filters) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/invited/sendsms',
      data: {
        extradata: filters.extradata,
        search: filters.search,
        socialNetworks: filters.socialNetworks,
        message: message
      }
    }

    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) {
          return reject(new Error(error.message))
        } else {
          return reject(new Error(message.data.error))
        }
      })
  })
}

users.uploadInvitationsFileAndSendSms = (token, companyId, appId, message, file) => {
  return new Promise((resolve, reject) => {
    /* eslint-disable */
    let fd = new FormData()
    /* eslint-enable */
    fd.append('message', message)
    fd.append('upload-files', file)

    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/upload/invitation',
      data: fd
    }

    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) {
          return reject(new Error(error.message))
        } else {
          return reject(new Error(message.data.error))
        }
      })
  })
}
users.verifyEmail = async (token, companyId, appId, email) => {
  try {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        emailToVerify: email
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/verify/email/'
    }
    const response = await axios(options)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) {
      throw new Error(e.message)
    } else {
      throw new Error(message.data.error)
    }
  }
}

users.exportFileUsers = (token, companyId, appId, objData) => {
  const { fileName } = objData
  return new Promise((resolve, reject) => {
    const request = {
      method: 'POST',
      responseType: 'blob',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/users/exports'
    }
    axios(request)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${fileName}.csv`)
        document.body.appendChild(link)
        link.click()
        resolve(true)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

export default users
